export function PlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="60"
      viewBox="0 0 52 60"
      fill="none">
      <path
        d="M49 28.2679C50.3333 29.0377 50.3333 30.9622 49 31.732L50 33.4641L49 31.732L5.49999 56.8468C4.16667 57.6166 2.5 56.6543 2.5 55.1147L2.5 4.88523C2.5 3.34564 4.16666 2.38339 5.5 3.15319L49 28.2679Z"
        fill="white"
        stroke="url(#paint0_linear_148_6606)"
        stroke-width="4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_148_6606"
          x1="0.5"
          y1="0.87927"
          x2="26.9002"
          y2="68.8671"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#F3EBFF" />
          <stop offset="0.5" stop-color="#B98DFF" />
          <stop offset="1" stop-color="#5D2EFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
